import { render, staticRenderFns } from "./ParentalResponsibilities.vue?vue&type=template&id=0eed1982"
import script from "./ParentalResponsibilities.vue?vue&type=script&lang=ts"
export * from "./ParentalResponsibilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports